/** @jsxImportSource davaux/client */
import { reactive } from 'davaux'
import { createSignal } from 'davaux/client'

function CloseIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 16 16'
      width='1em'
      height='1em'
      fill='none'
      stroke='currentColor'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    >
      <path d='M3 3l10 10M13 3L3 13' />
    </svg>
  )
}

function Modal({
  opened = false,
  title,
  body = '',
  triggerLabel,
  size = 'md',
  centered = false,
  fullScreen = false,
}: {
  opened?: boolean
  title?: string
  body?: string
  triggerLabel?: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'auto' | 'full'
  centered?: boolean
  fullScreen?: boolean
}) {
  const [open, setOpen] = createSignal(opened)

  function close() {
    setOpen(false)
  }

  function handleOverlayClick() {
    close()
  }

  function handleContentKeyDown(e: KeyboardEvent) {
    if (e.key === 'Escape') close()
  }

  return (
    <div class='dv-modal-root'>
      {triggerLabel && (
        <button
          type='button'
          class='dv-modal-trigger dv-button'
          data-variant='filled'
          onClick={() => setOpen(true)}
        >
          {triggerLabel}
        </button>
      )}
      <div
        class='dv-modal'
        data-opened={() => open() || undefined}
        data-centered={centered || undefined}
        data-full-screen={fullScreen || undefined}
        onKeyDown={handleContentKeyDown}
      >
        <div class='dv-modal-overlay' onClick={handleOverlayClick} aria-hidden='true' />
        <div class='dv-modal-content' data-size={size} role='dialog' aria-modal='true'>
          <div class='dv-modal-header'>
            {title && <span class='dv-modal-title'>{title}</span>}
            <button type='button' class='dv-modal-close' onClick={close} aria-label='Close'>
              <CloseIcon />
            </button>
          </div>
          <div class='dv-modal-body' dangerouslySetInnerHTML={{ __html: body }} />
        </div>
      </div>
    </div>
  )
}

export default reactive(Modal)
